export var NotificationChannelType;
(function (NotificationChannelType) {
    NotificationChannelType[NotificationChannelType["GOLDEN"] = 1] = "GOLDEN";
    NotificationChannelType[NotificationChannelType["SMS"] = 2] = "SMS";
    NotificationChannelType[NotificationChannelType["EMAIL"] = 3] = "EMAIL";
})(NotificationChannelType || (NotificationChannelType = {}));
//# sourceMappingURL=NotificationChannelType.js.map